import { PORTFOLIO } from "../../data/content";
import { SectionHeading, GhostButton } from "../primitives";
import PortfolioCard from "../PortfolioCard";

export default function PortfolioPreview() {
  return (
    <section data-testid="portfolio-preview" className="relative bg-ink-soft/40 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <SectionHeading
            eyebrow="Selected work"
            title="Work we're proud to put our name on"
            sub="A look at recent projects — built with craft, launched with care."
          />
          <GhostButton to="/portfolio" className="hidden shrink-0 md:inline-flex" data-testid="portfolio-view-all">
            View full portfolio
          </GhostButton>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {PORTFOLIO.slice(0, 3).map((p, i) => (
            <PortfolioCard key={p.id} project={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
